import { VoiceChat } from '@/components/VoiceChat';

export default function Chat() {
  return (
    <div className="container mx-auto p-4">
      <VoiceChat />
    </div>
  );
} 